import React from 'react';
import Mark from '../../components/mark/mark.js';

function addMark(textToHighlight, markRest) {
  return textToHighlight.trim() ? /*#__PURE__*/React.createElement(Mark, Object.assign({}, markRest), textToHighlight) : textToHighlight;
}
function highlightText(text, query, markRest) {
  if (!text.trim() || !query || !query.trim()) {
    return text;
  }
  // 'query.replace' called to sanitize the input and prevent malicious code to crash the app
  // place sanitized query in parenthesis to include it in the split result, enabling replacement
  // 'gi' makes it case insensitive, could be changed to 'g' to make it case sensitive.
  // e.g.:  caseSensitive ? 'g' : 'gi'
  const regex = new RegExp("(".concat(query.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&'), ")"), 'gi');
  const highlightedText = text.split(regex).filter(part => part !== '').map((part, i) => part.match(regex) ? addMark(part, markRest || {
    key: "".concat(text, "-").concat(i)
  }) : part);
  // if no query is found in text to highlight, return original text without array
  return highlightedText.length === 1 ? highlightedText[0] : highlightedText;
}

export { addMark, highlightText as default, highlightText };
